import React, { useState, useEffect } from "react";
import { Box, Button, TextField, Typography, InputAdornment, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import ClearIcon from "@mui/icons-material/Clear";

export default function UserHeader({ onCreateClick, onSearch }) {
  const [query, setQuery] = useState("");

  // debounce search to reduce calls while typing
  useEffect(() => {
    const t = setTimeout(() => {
      onSearch?.(query);
    }, 300);
    return () => clearTimeout(t);
  }, [query, onSearch]);

  return (
    <Box display="flex" justifyContent="space-between" alignItems="center" mb={2} p={2}>
      <Typography variant="h5" fontWeight="bold">
        User Management
      </Typography>

      <Box display="flex" gap={2} alignItems="center">
        <TextField
          size="small"
          placeholder="Search user..."
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          InputProps={{
            endAdornment: query ? (
              <InputAdornment position="end">
                <IconButton size="small" onClick={() => setQuery("")}> 
                  <ClearIcon fontSize="small" />
                </IconButton>
              </InputAdornment>
            ) : null,
          }}
        />

        <Button
          variant="contained"
          startIcon={<AddIcon />}
          sx={{ backgroundColor: "#e76f51" }}
          onClick={onCreateClick}
        >
          Create User
        </Button>
      </Box>
    </Box>
  );
}
 